import React from "react";
import { motion } from "framer-motion";
import {
  FaHome,
  FaBuilding,
  FaKey,
  FaHandshake,
  FaChartLine,
  FaRegCompass,
} from "react-icons/fa";

const services = [
  {
    id: 1,
    title: "Luxury Home Sales",
    description:
      "Find and own your dream home in prime locations with top-notch amenities.",
    icon: <FaHome className="text-4xl text-blue-600" />,
  },
  {
    id: 2,
    title: "Property Management",
    description:
      "We manage your properties with care, ensuring maximum returns and peace of mind.",
    icon: <FaBuilding className="text-4xl text-blue-600" />,
  },
  {
    id: 3,
    title: "Rental Services",
    description:
      "Get access to the best rental deals for residential and commercial properties.",
    icon: <FaKey className="text-4xl text-blue-600" />,
  },
  {
    id: 4,
    title: "Real Estate Consultancy",
    description:
      "Expert advice on property investments, valuations, and acquisition strategies.",
    icon: <FaHandshake className="text-4xl text-blue-600" />,
  },
  {
    id: 5,
    title: "Market Insights",
    description:
      "Stay informed with real-time insights and property market trends in Ghana.",
    icon: <FaChartLine className="text-4xl text-blue-600" />,
  },
  {
    id: 6,
    title: "Project Development",
    description:
      "From concept to completion, we help you develop properties that inspire.",
    icon: <FaRegCompass className="text-4xl text-blue-600" />,
  },
];

const Services = () => {
  return (
    <section className="bg-gray-50 py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto text-center mb-12">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-gray-900"
        >
          Our <span className="text-blue-600">Services</span>
        </motion.h2>
        <div className="w-24 h-1 bg-blue-600 mx-auto mt-3 rounded-full"></div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-gray-600 max-w-2xl mx-auto mt-5"
        >
          At Solonet Properties, we provide world-class real estate services designed
          to help you buy, sell, rent, and manage properties with ease.
        </motion.p>
      </div>

      {/* Service Cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <motion.div
            key={service.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition duration-300 group"
          >
            {/* Icon */}
            <div className="flex justify-center mb-6">{service.icon}</div>

            {/* Title */}
            <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
              {service.title}
            </h3>

            {/* Description */}
            <p className="text-gray-600 text-center">{service.description}</p>

            {/* Hover Effect */}
            <div className="mt-6 w-full h-1 bg-blue-600 scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
